import React, { useEffect, useState } from 'react'
import Sidebar from '@/components/ui/Sidebar/Sidebar'
import { Button } from '@/components/ui/Button'
import type { SharedUser } from '@/services/api/sharingService'

interface EditUserSidebarProps {
  isOpen: boolean
  onClose: () => void
  currentSharedUser?: SharedUser | null
  onSave?: (opts: { handOverOwnership: boolean }) => void | Promise<void>
}

const EditUserSidebar: React.FC<EditUserSidebarProps> = ({
  isOpen,
  onClose,
  currentSharedUser,
  onSave,
}) => {
  const [handOverOwnership, setHandOverOwnership] = useState<boolean>(false)

  useEffect(() => {
    // Reset toggle when opening for a different user
    setHandOverOwnership(false)
  }, [currentSharedUser?.objectId, isOpen])

  return (
    <Sidebar isOpen={isOpen} onClose={onClose} title="Edit User Permission">
      <div className="space-y-4">
        {/* Email display */}
        <div className="p-4 rounded-lg border border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-900">
          <div className="text-sm text-gray-600 dark:text-gray-300">User Email</div>
          <div className="mt-1 text-sm font-medium text-gray-900 dark:text-gray-100">
            {currentSharedUser?.inviteEmail || '-'}
          </div>
        </div>

        {/* Hand Over Ownership option */}
        <div className="p-4 rounded-lg border border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-900">
          <label className="inline-flex items-center gap-2">
            <input
              type="checkbox"
              checked={handOverOwnership}
              onChange={(e) => setHandOverOwnership(e.target.checked)}
            />
            <span className="text-sm">Hand over Ownership</span>
          </label>
          <div className="mt-2 text-xs text-gray-500 dark:text-gray-400">
            The new owner will gain full control of the SplashMe device.
          </div>
        </div>

        {/* Actions */}
        <div className="flex items-center justify-end gap-2">
          <Button
            variant="solid"
            disabled={!handOverOwnership}
            onClick={() => onSave?.({ handOverOwnership })}
          >
            Save
          </Button>
          <Button variant="default" onClick={onClose}>Cancel</Button>
        </div>
      </div>
    </Sidebar>
  )
}

export default EditUserSidebar